<script setup lang="ts">
import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';

const { collapseTitle = 'کمتر', expandTitle = 'بیشتر' } = defineProps<{
    disabled?: boolean;
    collapseTitle?: string;
    expandTitle?: string;
}>();

const COLLAPSE_MS = 280;

const expand = ref(false);
const moreButton = ref<HTMLElement | null>(null);

function toggleExpand() {
    if (!expand.value) {
        expand.value = true;
        return;
    }

    const buttonEl = moreButton.value;
    const topBefore = buttonEl?.getBoundingClientRect().top ?? 0;
    expand.value = false;

    const startedAt = performance.now();
    const keepButtonPinned = (now: number) => {
        if (buttonEl) {
            const delta = buttonEl.getBoundingClientRect().top - topBefore;
            if (delta) {
                window.scrollBy(0, delta);
            }
        }
        if (now - startedAt < COLLAPSE_MS) {
            requestAnimationFrame(keepButtonPinned);
        }
    };
    requestAnimationFrame(keepButtonPinned);
}
</script>
<template>
    <div class="root-container">
        <slot :expand />
        <div class="more-wrapper" :class="{ expand }">
            <div class="more-inner">
                <slot name="more" :expand />
            </div>
        </div>
        <div v-if="!disabled" ref="moreButton" class="more-button">
            <slot name="more-button" :expand>
                <mr-button
                    size="medium"
                    variant="transparent"
                    :left-icon="expand ? faChevronUp : faChevronDown"
                    @click="toggleExpand"
                >
                    {{ expand ? collapseTitle : expandTitle }}
                </mr-button>
            </slot>
        </div>
    </div>
</template>
<style scoped lang="scss">
.root-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    .more-wrapper {
        display: grid;
        grid-template-rows: 0fr;
        // Prefer anchoring to the button below, not the collapsing items.
        overflow-anchor: none;
        transition: grid-template-rows 280ms cubic-bezier(0.4, 0, 0.2, 1);
        &.expand {
            grid-template-rows: 1fr;
        }
    }

    .more-inner {
        overflow: hidden;
    }

    .more-button {
        align-self: center;
    }
}
</style>
